import { refreshToken } from "../actions/authentication"

export default (err, dispatch) => {
  const deferred = new Promise((resolve, reject) => {
    if (err.status === 401) {
      dispatch(refreshToken())
        .then(resolve)
        .catch(reject)
    } else {
      reject(err)
    }
  })
  return deferred
}
